// removed by extract-text-webpack-plugin
module.exports = {"Content":"HandlingUserData-module__Content__2cs5Z","HrLine":"HandlingUserData-module__HrLine__2zTv3"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/localization/hud/HandlingUserData.module.css
// module id = 118
// module chunks = 31